var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.toPay)?_c('div',{staticClass:"payment-info-wrapper"},[_c('div',{staticClass:"payment-info-total"},[_vm._v(_vm._s(_vm.$t('total-payment')))]),_c('div',{staticClass:"payment-info-price",style:({ color: _vm.color })},[_vm._v(_vm._s(_vm._f("money")(_vm.toPay,_vm.$i18n.locale)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }